export const theme = {
  colors: {
    // Dark green brand

    bg: "#000000",
    surface: "#121A17",
    textPrimary: "#E8F0EC",
    textSecondary: "#A9BBB4",
    accent: "#12B886",
    border: "#1E2A26",

    // Backward-compatible tokens used across components
    primary: {
      50: "#0b2a22",
      100: "#0f3a2e",
      200: "#13533f",
      300: "#167a58",
      400: "#19a16f",
      500: "#12B886",
      600: "#0ea172",
      700: "#0b855e",
      800: "#0a6a4d",
      900: "#084e3b",
    },
    secondary: {
      50: "#0c1f1b",
      100: "#0f2923",
      200: "#13362d",
      300: "#174339",
      400: "#1b5044",
      500: "#1f5d4f",
      600: "#236a59",
      700: "#287965",
      800: "#2d8870",
      900: "#32977c",
    },
    gray: {
      50: "#0F1412",
      100: "#141B18",
      200: "#1B2420",
      300: "#222D28",
      400: "#2A3731",
      500: "#6F837A",
      600: "#8FA099",
      700: "#A9BBB4",
      800: "#D4DFDA",
      900: "#E8F0EC",
    },
    white: "#ffffff",
    black: "#000000",
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
  },
  spacing: {
    0: "0",
    1: "0.25rem",
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    8: "2rem",
    10: "2.5rem",
    12: "3rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    32: "8rem",
    40: "10rem",
    48: "12rem",
    56: "14rem",
    64: "16rem",
  },
  breakpoints: {
    mobile: "768px",
    tablet: "1024px",
    desktop: "1280px",
  },
  borderRadius: {
    sm: "0.375rem",
    base: "0.5rem",
    md: "0.75rem",
    lg: "1rem",
    xl: "1.5rem",
    "2xl": "2rem",
    full: "9999px",
  },
  shadows: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.25)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.35), 0 1px 2px 0 rgba(0, 0, 0, 0.25)",
    md: "0 4px 10px -1px rgba(0,0,0,0.4), 0 2px 6px -1px rgba(0,0,0,0.3)",
    lg: "0 10px 20px -3px rgba(0,0,0,0.45), 0 4px 8px -2px rgba(0,0,0,0.4)",
    xl: "0 20px 30px -5px rgba(0,0,0,0.5), 0 10px 12px -5px rgba(0,0,0,0.45)",
  },
  zIndex: {
    base: 0,
    behind: -1,
    above: 10,
    dropdown: 1000,
    sticky: 1020,
    overlay: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },
};

export default theme;
